import React from "react";
import AnunciosTemplate from "../components/templates/AnunciosTemplate";

const Anuncios = () => {
    return <AnunciosTemplate />;
};

export default Anuncios;